import { useState } from 'react'
import { createPortal } from 'react-dom'
import { useTranslation } from 'react-i18next'
import { useLocation } from 'react-router-dom'
import { Logo, Press } from '@dorixona/ui'
import { Flag } from '../ui/Flag'
import { hasChosenLanguage, useLanguage } from './language'

/**
 * Приветствие при первом заходе: логотип и выбор языка. Показывается один
 * раз — пока языка нет в localStorage; выбор здесь или переключателем его
 * туда кладёт. Текст — по-русски, а каждый язык подписан на себе самом;
 * оба варианта равноправны — никакой не выделен.
 */
/** Страницы, на которых приветствие не показываем. */
const NO_WELCOME = ['/privacy-policy']

export function WelcomeLanguage() {
  const { t } = useTranslation('common')
  const { languages, change } = useLanguage()
  const [open, setOpen] = useState(() => !hasChosenLanguage())
  const { pathname } = useLocation()

  // Юридический документ открывают по прямой ссылке (магазин приложений,
  // регистрация): он только по-русски, и выбор языка его бы заслонил.
  // Уйдут с него на витрину — приветствие покажется там.
  if (!open || NO_WELCOME.includes(pathname)) return null

  return createPortal(
    <div className="welcome" role="dialog" aria-modal="true" aria-labelledby="welcome-title">
      <div className="welcome__hero">
        <Logo onDark className="welcome__logo" />
        <p className="welcome__tag">{t('welcome.tagline', { lng: 'ru' })}</p>
      </div>

      <div className="welcome__panel">
        <h1 id="welcome-title">{t('welcome.title', { lng: 'ru' })}</h1>
        <p className="welcome__pick">{t('welcome.pick', { lng: 'ru' })}</p>
        <div className="welcome__langs">
          {languages.map((code) => (
            <Press
              key={code}
              squish="row"
              haptic="select"
              lang={code}
              className="welcome__opt"
              onPress={() => {
                change(code)
                setOpen(false)
              }}
            >
              <Flag code={code} className="welcome__flag" />
              <span className="welcome__name">{t(`language.${code}`, { lng: code })}</span>
              <svg className="welcome__chev" viewBox="0 0 24 24" aria-hidden="true">
                <path
                  d="m9 5 7 7-7 7"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </Press>
          ))}
        </div>
      </div>
    </div>,
    document.body,
  )
}
